import { Component, inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialog as MatDialog
} from '@angular/material/legacy-dialog';
import { MatLegacyDialogRef as MatDialogRef } from "@angular/material/legacy-dialog";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ConfirmDialogComponent, ConfirmDialogModel } from "@shared/dialogs/confirm-dialog/confirm-dialog.component";

@Component({
  selector: 'app-pd-multi-select-dialog',
  templateUrl: './pd-multi-select-dialog.component.html',
  styleUrls: ['./pd-multi-select-dialog.component.scss']
})
export class PdMultiSelectDialogComponent implements OnInit {
  private fb: FormBuilder = inject(FormBuilder);
  private matDialogRef: MatDialogRef<PdMultiSelectDialogComponent> = inject(MatDialogRef);
  private dialog: MatDialog = inject(MatDialog);

  public form: FormGroup;
  public data: any = inject(MAT_DIALOG_DATA);

  public ngOnInit(): void {
    this.initForm(this.data);
  }

  public initForm(data: any): void {
    const mappedCurrentList: any[] = data.dataPointList.map((item: any) => ({
      value: item.value,
      name: item.name,
      slug: item.slug,
      datapoint: item.datapoint,
      id: item.id,
    }));

    this.form = this.fb.group({
      list: [mappedCurrentList]
    });
  }

  public onChanged(event: any): void {
    this.form.get('list')?.setValue(event);
  }

  public get dataPointListControl(): any {
    return this.form.get('list');
  }

  public get dataPointListValue(): any {
    return this.form.get('list')?.value;
  }

  public get optionList(): any {
    return this.data.optionList;
  }

  public close(): void {
    this.matDialogRef.close(false);
  }

  public save(): void {
    if (this.data.yAxisOrder === 1 && !this.dataPointListValue.length) {
      const message: string =
        'Removing all metrics from Axis Y1 will make this graph collapse. As soon as you add a metric to Y1 the graph will be visible again.';
      const dialogData:ConfirmDialogModel = new ConfirmDialogModel(
        'Are You Sure?',
        message,
        'Proceed',
        'Go Back'
      );
      const dialogRef: MatDialogRef<ConfirmDialogComponent> = this.dialog.open(ConfirmDialogComponent, {
        width: '400px',
        data: dialogData,
        disableClose: true,
      });

      dialogRef.afterClosed().subscribe({
        next: (res: boolean) => {
          if (res) {
            this.matDialogRef.close(this.dataPointListValue);
          }
        },
      });
    } else {
      this.matDialogRef.close(this.dataPointListValue);
    }
  }
}
